import { Pipe, PipeTransform } from '@angular/core';

import { settings } from '../../app.settings';

const API_PATH = settings.api.url;

@Pipe({
  name: 'imageFromApi'
})
export class ImageFromApiPipe implements PipeTransform {
    transform(value: any, placeholder: string = '/assets/img/placeholder.svg') {
      if (value && ((value.links && value.links.preview) || value.url || value.id)) {
        if (value.links) {
          return value.links.preview;
        } else if (value.url) {
          return settings.api.url + value.url;
        } else if (value.id) {
          return API_PATH + '/files/' + value.id + '/preview';
        }
      }

    return placeholder;
  }
}
